import type { Proveedor, ProveedorEdicion, ProveedorEntrada } from '@serkat/shared'
import { api, queryString } from '../../api/cliente'

export interface Pagina {
  datos: Proveedor[]
  total: number
  pagina: number
  porPagina: number
}

export interface FiltroProveedores {
  pagina: number
  porPagina: number
  buscar?: string
  activo?: 'true' | 'false'
}

export const proveedoresApi = {
  listar: (f: FiltroProveedores) => api.get<Pagina>(`/proveedores${queryString({ ...f })}`),
  obtener: (id: string) => api.get<Proveedor>(`/proveedores/${id}`),
  crear: (datos: ProveedorEntrada) => api.post<Proveedor>('/proveedores', datos),
  actualizar: (id: string, datos: ProveedorEdicion) =>
    api.patch<Proveedor>(`/proveedores/${id}`, datos),
  eliminar: (id: string) => api.delete<void>(`/proveedores/${id}`),
}
